import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerPlatformActionMessages(locale: SupportedLocale): Promise<void> {
  // The NAMESPACE, not the directory: the loader derives `features/platform-actions/` from it.
  return registerFeatureMessages('platformActions', locale)
}
